module.exports = __webpack_public_path__ + "img/scroll_left.c715706f.png";